import Image from "next/image";

import { androidLink, iosLink } from "const/links";

import { BadgeLink, BadgesRow, ComingSoon } from "./StoreBadges.styled";

export default function StoreBadges({ compact, align }) {
	const height = compact ? 36 : 48;
	const width = compact ? 120 : 160;
	const playReady = Boolean(androidLink);

	return (
		<BadgesRow compact={compact} align={align}>
			<BadgeLink href={iosLink} title="Download on the App Store" target="_blank" rel="noopener noreferrer">
				<Image
					unoptimized
					src="/assets/app_store_badge.svg"
					alt="Download on the App Store"
					width={width}
					height={height}
					style={{ width, height: "auto" }}
				/>
			</BadgeLink>
			<BadgeLink
				as={playReady ? "a" : "span"}
				href={playReady ? androidLink : undefined}
				title={playReady ? "Get it on Google Play" : "Google Play coming soon"}
				target={playReady ? "_blank" : undefined}
				rel={playReady ? "noopener noreferrer" : undefined}
				disabled={!playReady}
			>
				<Image
					unoptimized
					src="/assets/play_store_badge.svg"
					alt="Get it on Google Play"
					width={width}
					height={height}
					style={{ width, height: "auto" }}
				/>
				{!playReady && !compact && <ComingSoon>Coming soon</ComingSoon>}
			</BadgeLink>
		</BadgesRow>
	);
}
